/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Document_UploadInputs */

const vi_grower_document_upload = /** @type {(inputs: Grower_Document_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải CCCD`)
};

/**

* @param {Grower_Document_UploadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_document_upload = /** @type {((inputs?: Grower_Document_UploadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Document_UploadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_document_upload(inputs)
});